'use strict';
import util from './util';
import currentLayout from './detect-layout';
let resizedScreen = currentLayout.init();
/**
 * @function
 * @description Mobile navigation open/close handler
 */
function mobileNavHandler() {
	var windowScrollPosition;
	$(document).on('click','.icon-hamburger', function() {
		if (window.innerWidth < 1024) {
			$(this).hide();
			windowScrollPosition = $(window).scrollTop();
			// Scroll to the top to remove the flicker effect before the body scrolls off using CSS by nav-open class.
			$(window).scrollTop(0);
			$('html').addClass('nav-open');
			$('html').addClass('filter-open');
			$('.top-navigation-list').scrollTop(0);
			if($('.nav-redesign').length  && $(window).width() < 991) {
				$(".hamburger-icon, .offers-link a").attr("tabindex", "-1");
				$('.search-btn-close.icon-close').hide();
			}
			$('.suggestions-wrapper_active').length > 0 && $('.new-ico.ico-search').show();
			if($('.level-1 .nav-image').length) {
				$('li.has-sub-menu').each(function() {
					if($(this).find('.nav-image').length == 0) {
						$(this).find('a.level1-cat-name').css('padding-left', '130px');
					}
				});
				$('li.no-sub-menu').each(function() {
					if($(this).find('.nav-image').length == 0) {
						$(this).find('a.level1-cat-name').css('padding-left', '130px');
					}
				})
			} else if($('.cat-nav-mobile').length) {
				$('li.cat-nav-mobile a.level1-cat-name').css('padding-left', '14px');
			}	
		}
	});

	$('.level1-cat-name').on('click', function() {
		if($(this).next().find('.level-2 .nav-image').length) {
			$('li.level-2-sub-col').each(function() {
				if($(this).find('.nav-image').length == 0) {
					const $this = $(this);
					$this.find('span').css('padding-left', '32px');
					$this.find('a').css('padding-left', '32px');
				}
			  });
		} else {
			const $level2Col = $('.level-2 li.level-2-sub-col')
			$level2Col.find('a').css('padding-left', '0');
			$level2Col.find('span').css('padding-left', '0');
			$level2Col.find('li.sub-menu-2-content a').css('padding-left', '20px');
		}
	});

	$('.nav-container, .mobile-header-display').on('click', '.nav-overlay, .mobile-nav-close', function () {
		if ($('.nav-open').length > 0) {
			$('html').removeClass('nav-open');
			$('html').removeClass('filter-open');
			$(window).scrollTop(windowScrollPosition);
			$('.main-nav, .main-sub-nav, .sub-menu, #signin-overlay').removeClass('active').removeAttr('style');
			$('.main-nav, .main-sub-nav, .sub-menu, #contactus-overlay').removeClass('active').removeAttr('style');
			$('.suggestions-wrapper_active').length > 0 && $('.new-ico.ico-search').hide();
			$('.icon-hamburger').show();
			if($('.nav-redesign').length) {
				$(".hamburger-icon, .offers-link a").attr("tabindex", "0");
				if($('.suggestions-enabled').hasClass('modal-open')) {
					$('.search-btn-close.icon-close').show();
				}
			}
		}
	}).on('click', '.has-sub-nav > a', function (e) {
		$('.utility-nav > ul > li').removeClass('hovered');
		if (window.innerWidth < 1024) {
			$(this).siblings('.sub-menu, .main-sub-nav').addClass('active');
			$('.main-nav').removeAttr('style');
			return false;
		}
	}).on('click', '.back-link span .icon-leftCarrot, .back-link span .cat-name', function () {
		if ($(this).parents('.back-link-wrapper').next('.sub-menu').hasClass('level-2')) {
			$(this).closest('.main-sub-nav').removeClass('active');
		} else {
			$(this).parent('.back-link-wrapper').next('.sub-menu').removeClass('active');
		}
	});
}

/**
 * @function
 * @description Desktop navigation flyout open/close handler
 */
function desktopNavHandler() {
	if (window.innerWidth >= 1024) {
		$(".mobile-header-display-right").remove();
		$('#navigation, .homepage-search-placeholder').on('mouseenter', function () {
			$(".redesign-nav").addClass("menu-hover-active");
		});
		$('#navigation, .homepage-search-placeholder').on('mouseleave', function () {
			const isHoveredNav = $('#navigation').is(":hover");
			const isHoveredSearch = $('.homepage-search-placeholder').is(":hover");
			if(!isHoveredNav && !isHoveredSearch) {
				setTimeout(function() {
					$(".redesign-nav").removeClass("menu-hover-active");
				}, 500);
			}
		});
	}
	$(document).on('mouseenter', '.top-navigation-list > li:not(.js-hover)', function () {
		if (window.innerWidth >= 1024) {
			var $this = $(this);

			if($('.nav-redesign').length) {
				if($this.is(":hover") || $this.children('a').is(":focus")) {
					$('.top-navigation-list .level-2-wrapper').scrollTop(0);
					$this.addClass('js-hover').siblings('li').removeClass('js-hover');
					$('.level-2-wrapper').removeClass('push-promo-enabled category-enabled');
					
					// column width calculation
					const $colCount = $this.find('.level-2.sub-menu li.level-2-sub-col').length;
					const $containerWidth = $this.find('.level-2-container').width() - 60;
					const $level2Target = $('.level-2-container .level-2');
					
					

					// check category visibility enabled
					if($this.find('.nav-cat-vis').length) {
						$('.level-2-wrapper').addClass('category-enabled').removeClass('push-promo-enabled');
						$('.level-2-container .level-2').css('justify-content', 'center');
						$level2Target.removeClass('column-spacing-15');
						$this.find('.level-2.sub-menu li.level-2-sub-col').css('max-width', '100%');
						if($colCount > 3) {
							$this.find('.level-2.sub-menu li.level-2-sub-col').addClass('reduce-space-col');
						}
						const $colElement = $this.find('.level-2.sub-menu li.reduce-space-col .column li')
						if($colCount > 4 && (window.innerWidth < 1300 && window.innerWidth > 1000)) {
							$colElement.addClass('reduce-menu-column');
						} else {
							$colElement.removeClass('reduce-menu-column');
						}
						// category banner image width calculation
						const $totalWidth = $(window).width();
						const $offsetCategory = $this.find('.nav-cat-vis').offset().left;
						const $catImageWidth = $totalWidth - $offsetCategory;
						$this.find('.category-banner').css('width', $catImageWidth + 'px');
						const $menuHeight = $this.find('.level-2-full-width').height();
						$this.find('.category-banner').css('height', $menuHeight + 'px');
					}
					if(!$this.find('.nav-cat-vis').length && !$this.find('.push-promo-enabled').length && $colCount <= 3) {
						$level2Target.addClass('column-spacing-15');
					} else {
						$level2Target.removeClass('column-spacing-15');
					}

					// check push promo enabled
					if($this.find('.promo-content-wrapper').length) {
						const $colCount = $this.find('.level-2.sub-menu li.level-2-sub-col').length;
						
						$('.level-2-wrapper').addClass('push-promo-enabled').removeClass('category-enabled');
						if($colCount > 5) {
							$this.find('.promo-content-wrapper').addClass('reduce-promo-wrapper');
						}
						if($colCount > 4 && $(window).width() < 1600) {
							$this.find('.level-2.sub-menu li.level-2-sub-col').addClass('reduce-space-col');
						}
						if($colCount >= 4 && $(window).width() < 1440) {
							$this.find('.promo-content-wrapper').css('width', '298px');
							if($(window).width() < 1337 && $(window).width() >= 1024 ) {
								$this.find('.promo-content-wrapper').addClass('reduce-promo-wrapper');
							}
						}
						let $menuHeight = $this.find('.level-2-full-width').outerHeight();
						$this.find('.promo-content-wrapper').height($menuHeight);
					}

					if ($this.find('.nav-cat-vis').length) return;

					if($this.find('.push-promo-enabled').length) {
						$level2Target.css('justify-content', 'left');
					} else if($colCount > 3) {
						$level2Target.css('justify-content', 'center');
						$this.find('.level-2.sub-menu li.level-2-sub-col').css('max-width', $containerWidth / $colCount + 'px');
					} else {
						$level2Target.css('justify-content', 'left');
					}
					
				}
			} else {
				setTimeout(function() {
					if($this.is(":hover") || $this.children('a').is(":focus")) {
						$('.top-navigation-list .level-2-wrapper').scrollTop(0);
						$this.addClass('js-hover').siblings('li').removeClass('js-hover');
					}
				}, 200);
			}
		}
	}).on('mouseleave', '.top-navigation-list > li', function () {
		if (window.innerWidth >= 1024) {
			var $this = $(this);
			setTimeout(function() {
				if(!$this.is(":hover")) {
					$('.top-navigation-list .level-2-wrapper').scrollTop(0);
					$this.removeClass('js-hover');
				}
			}, 200);
		}
	}).on('click', '.top-navigation-list > li > a', function () {
		if (window.innerWidth >= 1024) {
			$(this).parent('li').trigger('mouseenter');
		}
	}).on('click', '.top-navigation-list > li > .main-sub-nav .close', function () {
		if (window.innerWidth >= 1024) {
			$('.top-navigation-list .level-2-wrapper').scrollTop(0);
			$(this).closest('li.js-hover').removeClass('js-hover');
		}
	}).on('mouseenter', '.level-2-bottom-space', function () {
		if (window.innerWidth >= 1024) {
			$('.top-navigation-list .level-2-wrapper').scrollTop(0);
			$('.top-navigation-list > li.js-hover').removeClass('js-hover');
		}
	}).keyup(function(e) {
		  if (e.keyCode === 27) { //on click Esc key close the open menu flyout.
			  if ($('.top-navigation-list > li.js-hover').length > 0) {
				  $('.top-navigation-list > li.js-hover').trigger('mouseleave').children('a').focus();
			  }
		  }
	});

	if ($('.top-notification').length > 0) {
		$('.header-container').addClass('top-notification-configured');
	}
}

/**
 * @function
 * @description Utility navigation hover and click handling.
 */
function utilityNavTouchHandlerEvent(event, anchor) {
	if (resizedScreen == 'desktop' && util.isMobile()) {
		if (!$(anchor).parent().hasClass('hovered')) {
			$(anchor).parent().siblings().removeClass('hovered');
			$(anchor).parent().toggleClass('hovered');
			if ($(anchor).parent().hasClass('hovered')) {
				event.preventDefault();
			}
		}
	}
}

// toggle level 2 categories on mobile
function toggleSubMenuContent() {
    $('.open-nav-menu-content').on('click', function(e) {
        e.preventDefault();
        const $targetElement = $(this).parent();
        const $targetContentElement = $targetElement.next('.sub-menu-2-content');
        if (false === $targetContentElement.is(':visible')) {
			$('.sub-menu-2-content').slideUp(300);
            $('.icon-minus-fill').addClass('hidden');
            $('.icon-plus-fill').removeClass('hidden');
		}
        $targetContentElement.slideToggle(300);
        $targetElement.find('.icon-minus-fill').toggleClass('hidden');
        $targetElement.find('.icon-plus-fill').toggleClass('hidden');
    });
}

function redirectToPushPromoLink() {
    $('.promo-content-wrapper').click(function() {
        const $redirectLink = $(this).find('.promo-link').attr('href');
        window.location.href = $redirectLink;
    });
}

$(window).resize(function () {
	handleHomePageHeader();
});

function handleHomePageHeader() {
	const $headerClass = "handle-home-header";
	if(window.innerWidth == 1023  && $('.nav-redesign').length) {
		$(".header-container").addClass($headerClass);
	} else {
		$(".header-container").removeClass($headerClass);
	}
}
var lastScrollTop = 0;
//Function for sticky header behavior and other components impact of the same.
function initStickyHeader(){
	var threashHold = 50;
	const $collectionStickyPoint = $('.collection-header-content').length ? $('.collection-header-content').offset().top - 45 : 0;
	if($('#header-top-notification-message').length==0){
		threashHold = 30;
	}
	$(window).on('scroll', function () {
		var iCurScrollPos = $(window).scrollTop();
		
		if(!$('#wrapper').hasClass('pt_collectionrange')) {
			if (iCurScrollPos > lastScrollTop){
				//Downward Scroll
				if(!$('body').hasClass('pdp-page')){
					if(iCurScrollPos > threashHold){
						makeHeaderSticky();
					}else{
						removeStickyHeader();
					}
				}else{
					removeStickyHeader();
				}
			} else {
				if(!$('body').hasClass('pdp-page') || $(window).width() >= 768) {
					if(iCurScrollPos > threashHold){
						makeHeaderSticky();
					}else{
						removeStickyHeader();
					}
				}
			}
			lastScrollTop = iCurScrollPos;
		} else if ($('.collection-header-content').length) {
			if (iCurScrollPos > $collectionStickyPoint) {
				$('.collection-range-carousel').addClass('sticky-range');
			} else {
				$('.collection-range-carousel').removeClass('sticky-range');
			}
			$('.js-range-slider').slick('setPosition');
		}
	});
};

function makeHeaderSticky(){
	if(!$('#wrapper').hasClass('sticky-header') && !$('html').hasClass('filter-open')){
		$('#wrapper').addClass('sticky-header');
	}
};
function removeStickyHeader(){
	if($('#wrapper').hasClass('sticky-header')){
		$('#wrapper').removeClass('sticky-header');
	}
};

function ResizeForBannerMessageshandler(){
	var customMessagesTotalWidth = 0;
	$('.custom-message').each(function(i,m){customMessagesTotalWidth += $(m).outerWidth()});
	if(customMessagesTotalWidth>0 && window.innerWidth > customMessagesTotalWidth){
		$('#header-bottom-notification-message').addClass('centered');
	}else{
		$('#header-bottom-notification-message').removeClass('centered');
	}
}

function handleHeaderTopNotification () {
	if($('.top-banner-message-multiple').length || $('.top-banner-message').length) {
		var numberofmessage = $('.message-link').length;
		var count = $('.message-link').text().length;
		if(numberofmessage >1 ) {
			$('.message-link').css('animation-duration',(numberofmessage)*6+'s');
			$('.message-link').css('animation-name','notify'+numberofmessage);
			if(util.isMobile()) {
				$('.top-banner-message-multiple').children().each(function () {
					if($(this).text().length > 49) {
						$(this).addClass('small-font');
					} else {
						$(this).removeClass('small-font');
					}
				})
			}
		}
		else {
			if(util.isMobile()) {
				if(count>49) {
					$('.message-link').addClass('small-font');
					} else {
					$('.message-link').removeClass('small-font');
				}
			}
		}
		$('.header-container').addClass('top-banner-active');
	} else {
		$('div#main').addClass('without-top-banner');
	}
}

function handleHeaderBottomNotification() {
	$('#header-bottom-notification-message .header-bottom-notification-close').on('click',function(e) {
		e.preventDefault();
		$('#header-bottom-notification-message').remove();
		$(this).css('visibility','hidden');
	});
}

function getVisibleItems($container, $items) {
    const containerRect = $container[0].getBoundingClientRect();
    let visibleIndexes = [];

    $items.each(function (index) {
        let rect = this.getBoundingClientRect();
        let isVisible = rect.right > containerRect.left && rect.left < containerRect.right;

        if (isVisible) {
            visibleIndexes.push(index);
        }
    });
    return visibleIndexes;
}

let previousAnnouncement = '';
function updateLiveRegion($container, $items, $liveRegion) {
    let visible = getVisibleItems($container, $items);

    if (!visible.length) return;

    let first = visible[0] + 1;
    let last = visible[visible.length - 1] + 1;
    let total = $items.length;
    let message = Resources.QUICK_ACCESS_SHOWING_ITEMS + ' ' + first + ' ' + Resources.QUICK_ACCESS_TO + ' ' + last + ' ' + Resources.QUICK_ACCESS_OF + ' ' + total;
    
    if (message !== previousAnnouncement) {
        previousAnnouncement = message;
        $liveRegion.text('');
        setTimeout(function () {
            $liveRegion.text(message);
        }, 50);
    }
}

handleHeaderTopNotification();
$(window).on('resize', function() {
	handleHeaderTopNotification();
});

handleHeaderBottomNotification();

export const handleResizeForBannerMessages = function () {
	ResizeForBannerMessageshandler();
};

export const utilityNavTouchHandler = function (event, anchor) {
	utilityNavTouchHandlerEvent(event, anchor)
};
export const updatePosFromTop = function () {
	updatePosFromTop()
};

export default {
    init: function () {
	var currentCountry = $('.js-current-country').data('currentcountry');
	$(window).on('resize', function() {
		resizedScreen = currentLayout.init();
		resizeScreenInit();
		ResizeForBannerMessageshandler();
		
	});
	
	$(document).ready(function () {
        const $container = $('.plps-container');
        if (!$container.length) {
            return;
        }
        const $items = $container.find('a');
        let $liveRegion = $('#plps-status');

        $items.each(function (index) {
            let text = $.trim($(this).text());
            $(this).attr('aria-label', text + ', '+ Resources.QUICK_ACCESS_ITEMS + ' ' + (index + 1) + ' ' + Resources.QUICK_ACCESS_OF + ' ' + $items.length);
        });

        updateLiveRegion($container, $items, $liveRegion);
        $container.on('scroll', function () {
            updateLiveRegion($container, $items, $liveRegion);
        });
        $(window).on('resize', function () {
            updateLiveRegion($container, $items, $liveRegion);
        });
    });
	
	// 'tap' doesn't work as expected so using touchstart instead
	$(document).on('touchstart',function(e){
		// the tapped element
		var $target = $(e.target);
		
	});

	$('a.utility-link').on('click', function(evt) {
		evt.preventDefault();
	});
	
	$('.contactus-overlay-container').on('click', function(e) {	
		$('html').removeClass('sticky-header-contact');
		$('#contactus-overlay').removeClass('active');
		$('#contactus-overlay').hide();
		e.preventDefault();
		return false;
	});

	//Common signin-overlay close
	$('#signin-overlay .signin-overlay-close').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('html').removeClass('nav-open sticky-header-signin');
		$('body').removeClass('body-fixed');
		$(this).parents('#signin-overlay').removeClass('active');
		$(this).parents('#signin-overlay').hide();
		$('#signin-link').removeClass('hovered');
	});	
	
	$('#contactus-overlay .contactus-overlay-close').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('html').removeClass('nav-open sticky-header-contact');
		$(this).parents('#contactus-overlay').removeClass('active');
		$(this).parents('#contactus-overlay').addClass('d-none');
		$(this).parents('#contactus-overlay').hide();
		$('#contactus-link').removeClass('hovered');
	});

	function singinOverlayScroll () {
		if($('.signin-overlay .sb-content').length === 0) {
			$(".sb-container").scrollBox();
		} else {
			$('.signin-overlay .sb-content').removeAttr('style');
			$(window).trigger("resize.scrollBox");
		}
	}
	
	function handleSigninOverlayDisplay(){
		//Remove body fixed / sticky-header-signin after orientation change or resize in ipad landscape
		if($('#signin-overlay').is(':visible') && $('body').hasClass('body-fixed')) {
			$('body').removeClass('body-fixed');
			$('html').removeClass('sticky-header-signin');
		}
	}

	//Desktop contactus-overlay 
	function desktopContactusOverlay(){
		$('#contactus-link > a').on('mouseover', function(e){
			e.preventDefault();
			if($(".contactus-link").hasClass("active")) {
				$(".contactus-overlay").addClass("d-none");
			}
			$(this).nextAll('#contactus-overlay').removeAttr('style');
			$(".signin-link").removeClass('hovered');
			$(".minicart-link").removeClass('hovered');
		}).on('click', function() {
			utilityNavTouchHandlerEvent(event, this);
		});
	}

	//Desktop signin-overlay 
	function desktopSigninOverlay() {
		if(!$('#login-wrapper-new').length) {

			$(".courtesy-nav li.signin-link").hover(function(){  
				singinOverlayScroll();
			});  

			$('#signin-link > a').on('mouseover', function(e) {
				$(this).nextAll('#signin-overlay').removeAttr('style');
				singinOverlayScroll();
				$('#header-selectcountry').selectmenu('close');
			});
			$(document).on('click', '#signin-link > a', function(e) {
				utilityNavTouchHandlerEvent(event, this);
				$('#header-selectcountry').selectmenu('close');
				singinOverlayScroll();
			});
		}
	}

	//Mobile signin-overlay
	function mobileSigninOverlay() {
		$(document).on('click', '#signin-link > a', function(e) {
			if (window.innerWidth < 1024 && !$('#login-wrapper-new').length) {
				$('#signin-link').hasClass('guest') && e.preventDefault();
				$(this).parent().addClass('hovered').siblings().removeClass('hovered');

				if ($(this).hasClass('mobile-courtesy-sub-link')) {
					e.preventDefault();
				}  
			}
			if(window.innerWidth < 1024 && !$('#login-wrapper-new').length ) {
				var overlay = $(this).nextAll('#signin-overlay');
				overlay.removeAttr('style');
				overlay.addClass('active');
				$('.signin-link').addClass('hovered');
				var vHeight = overlay.find('.sign-in-dropdown').innerHeight();
				
				if($('.signin-overlay .sb-content').length > 0) {
					$('.signin-overlay .sb-content').removeAttr('style');
					$(window).trigger("resize.scrollBox");
				}

				if($('#signin-link').hasClass('guest')){
					$('html').addClass('sticky-header-signin');
					$('body').addClass('body-fixed');
				} 
				else {
					$(document).on('click', '#signin-overlay .back-link', function(e){
						e.preventDefault();
						$(this).parents('#signin-overlay').removeClass('active');
					});	
				}
			}
		});	
	}

	function mobileContactusOverlay() {
		$(document).on('click','#contactus-link > a, #contactus-link > .nav-toggle', function(e) {
			if (window.innerWidth < 1024) { 
				e.preventDefault();
				$(this).parent().addClass('hovered').siblings().removeClass('hovered');
			}
			$("html.nav-open").addClass("sticky-header-contact");
			var overlay = $(this).nextAll('#contactus-overlay');
			overlay.removeClass('d-none');
			overlay.removeAttr('style');
			overlay.addClass('active');
		});
	}

	function resizeScreenInit() {
		if(window.innerWidth < 1024) {
			mobileSigninOverlay();
		} else {
			desktopSigninOverlay();
			handleSigninOverlayDisplay();
		}

		$('.utility-nav > ul > li').toggleClass('no-touch', !util.isMobile());
	}

	$(window).on('orientationchange', function () {
		if(window.innerWidth >= 1024) {
			if ($('.nav-open').length > 0) {
				$('html').removeClass('nav-open');
				$('.main-nav, .main-sub-nav, .sub-menu, #signin-overlay').removeClass('active').removeAttr('style');
			}
		} else if(window.innerWidth <= 1024) {
			if($('.top-navigation-list > li.js-hover').length > 0) {
				$(window).scrollTop(0);
			}
		}
	});

	resizeScreenInit();
	initStickyHeader();
	mobileNavHandler();
	desktopNavHandler();
	ResizeForBannerMessageshandler();
	toggleSubMenuContent();
	redirectToPushPromoLink();
	handleHomePageHeader();
	},
	handleResizeForBannerMessages : handleResizeForBannerMessages,
	utilityNavTouchHandler : utilityNavTouchHandler,
	updatePosFromTop : updatePosFromTop
}